
export const DIALOG_IE_ALERT_CONTENT = "В Internet Explorer функциональность текстового редактора полей описания и инструкции по установке ограничена. Рекомендуем использовать другой браузер."